import(/* webpackMode: "eager", webpackExports: ["AppRouterI18nContext"] */ "/vercel/path0/apps/web/app/AppRouterI18nProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomI18nContext"] */ "/vercel/path0/apps/web/app/CustomI18nProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/react-inlinesvg/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useAtomsContext"] */ "/vercel/path0/packages/platform/atoms/hooks/useAtomsContext.ts");
;
import(/* webpackMode: "eager", webpackExports: ["SplitButton"] */ "/vercel/path0/packages/ui/components/button/SplitButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tooltip"] */ "/vercel/path0/packages/ui/components/tooltip/Tooltip.tsx");
